// userActions.js

import { LOGIN_REQUEST, REDIRCT_LOGIN } from './Constant';

export const fetchLoginRequest = (payload, loginType) => ({
    type: LOGIN_REQUEST,
    payload: payload,
    loginType : loginType == 1 ? 'email' : 'phone'
});

export const loginRedirectRequest = (payload) => ({
    type: REDIRCT_LOGIN,
    payload: payload,
});
  
//   export const fetchUserSuccess = (department) => ({
//     type: REQUEST_DEPARTMENT_LIST_SUCCESS,
//     payload: department,
//   });
  
//   export const fetchUserFailure = (error) => ({
//     type: REQUEST_DEPARTMENT_LIST_ERROR,
//     payload: error,
//   });
  